import { render, staticRenderFns } from "./RecipeItemIngredientDelete.vue?vue&type=template&id=f0b8cb28&"
import script from "./RecipeItemIngredientDelete.vue?vue&type=script&lang=js&"
export * from "./RecipeItemIngredientDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports